import { useRef, useLayoutEffect } from 'react';

const getScrollYPercent = () => {
  const docElement = document.documentElement;
  const body = document.body;

  return (
    ((docElement.scrollTop || body.scrollTop) /
      ((docElement.scrollHeight || body.scrollHeight) - docElement.clientHeight)) *
    100
  );
};

const getScrollPosition = (element) => {
  const target = element?.current || document.body;
  const position = target.getBoundingClientRect();

  return { x: position.left, y: position.top };
};

export function useScroll({ action, wait = 500 }) {
  const position = useRef(getScrollPosition());
  const element = useRef(null);
  const isWaiting = useRef(false);

  useLayoutEffect(() => {
    const handleScroll = () => {
      if (!isWaiting.current) {
        isWaiting.current = true;

        setTimeout(() => {
          const currPos = getScrollPosition(element);
          action({
            currPos,
            prevPos: position.current,
            yPercent: getScrollYPercent(),
          });

          position.current = currPos;
          isWaiting.current = false;
        }, wait);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [action, wait]);

  return element;
}
